(function () {
  function initIngredientsSearch() {
    var input = document.querySelector('[data-ingredient-search]');
    var cards = document.querySelectorAll('[data-ingredient-card]');
    var filters = document.querySelectorAll('[data-ingredient-filter]');

    if (!input || !cards.length) return;

    var activeCategory = 'all';

    function updateCards() {
      var query = input.value.toLowerCase().trim();

      cards.forEach(function (card) {
        var text = card.getAttribute('data-search') || '';
        var category = card.getAttribute('data-category') || '';
        var matchesSearch = !query || text.indexOf(query) !== -1;
        var matchesCategory = activeCategory === 'all' || category === activeCategory;

        card.style.display = matchesSearch && matchesCategory ? '' : 'none';
      });
    }

    input.addEventListener('input', updateCards);

    filters.forEach(function (filter) {
      filter.addEventListener('click', function () {
        filters.forEach(function (item) {
          item.classList.remove('is-active');
        });

        filter.classList.add('is-active');
        activeCategory = filter.getAttribute('data-ingredient-filter');
        updateCards();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initIngredientsSearch);
  document.addEventListener('shopify:section:load', initIngredientsSearch);
})();